import { Injectable } from '@angular/core'
import * as Autolinker from 'autolinker'

@Injectable()
export class ParserService {
  private imgRegex = /\.(jpe?g|png|gif)$/i
  private youtubeRegex = /https?:\/\/((www\.youtube\.com\/watch\?v=)|(youtu\.be\/))([a-zA-Z0-9_-]+)((\?|&)\w+\=\w+)?/i

  /**
   * Add links, images and embedded content to an html string
   */
  autolink (body: string): string {
    return body.replace(/<p>(.*?)<\/p>/g, (paragraph, content) =>
      // Inspect parapgraphes one after the other
      paragraph.replace(content, () =>
        Autolinker.link(content, {
          stripPrefix: { www: false },
          replaceFn: (match: any) => {
            const href = match.getAnchorHref()

            // img element
            if (this.imgRegex.test(href)) {
              return `<img src="${href}"/>`
            }

            // iframe to youtube
            if (this.youtubeRegex.test(href)) {
              const videoId = href.match(this.youtubeRegex)[4]
              return `<iframe src="https://www.youtube.com/embed/${videoId}"/>`
            }

            // Default (link)
            return true
          }
        })
      )
    )
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/parser.service.ts